module.exports = __webpack_public_path__ + "img/icon1.913b7068.png";